import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Overview = lazy(() => import('./Overview'));

const OverviewConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.billbuddyDark : themesConfig.billbuddy,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.billbuddyDark : themesConfig.billbuddy,
		}
	},
	routes: [
		{
			path: '/bb/overview',
			element: <Overview />,
			auth: authModules.bb_default
		}
	]
};

export default OverviewConfig;
